// API Configuration
const API_CONFIG = {
  // Base URLs
  BASE_URL: 'https://letsrevitup.com',
  
  // API Endpoints
  ENDPOINTS: {
    // Authentication endpoints
    OUTLOOK_API: '/api.php',

    // Email endpoints
    ARCHIVE_EMAIL: '/api.php',
  }
};

// Helper function to build full URL
export const buildApiUrl = (endpoint, baseUrl = API_CONFIG.BASE_URL) => {
  return `${baseUrl}${endpoint}`;
};

// Helper function to get endpoint
export const getEndpoint = (endpointKey) => {
  return API_CONFIG.ENDPOINTS[endpointKey];
};

// Export the full config
export default API_CONFIG;